import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import CareGuideForm from '../containers/CareGuideFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CareGuideEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `CareGuideEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('care_guide_route_edit')} />
          <CareGuideForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CareGuideEditScreen;

Logger.log('silly', `CareGuideEditScreen loaded.`);
